import script from "./UiOptionList.vue?vue&type=script&setup=true&lang=js"
export * from "./UiOptionList.vue?vue&type=script&setup=true&lang=js"

import "./UiOptionList.vue?vue&type=style&index=0&id=160a3fc4&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-160a3fc4"]])

export default __exports__